var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"role":"button","data-toggle":"modal","data-target":"#vehicleDeliveryModal"}},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"p-1"},[_vm._v("\n            "+_vm._s(this.availability)+"\n        ")]),_vm._v(" "),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-5 p-1"},[_c('i',{staticClass:"far fa-info-circle"})])
}]

export { render, staticRenderFns }